import type { DraftTemplateSectionOption } from "@/types/drafting";

export function parseTemplateSections(structure: unknown): DraftTemplateSectionOption[] {
  if (!structure || typeof structure !== "object") return [];
  const sections = (structure as { sections?: unknown }).sections;
  if (!Array.isArray(sections)) return [];

  return sections
    .map((section) => {
      if (!section || typeof section !== "object") return null;
      const row = section as { key?: string; title?: string };
      if (!row.key || !row.title) return null;
      return { key: row.key, title: row.title };
    })
    .filter((section): section is DraftTemplateSectionOption => Boolean(section));
}
